import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { UserDefinedLink } from "../UserDefinedLink/index.js";
async function LinkFlyout({
  entryId,
  locale,
  enableLivePreview,
  analyticsTitlePrefix
}) {
  let entry;
  if (entryId) {
    entry = await findOneBusinessEntry(
      ContentType.LinkFlyout,
      entryId,
      locale,
      DEFAULT_FIELD_EXCEPTIONS,
      enableLivePreview
    );
  } else {
    console.error("Error in LinkFlyout, expected `entryId` prop.");
    return null;
  }
  if (!entry || !entry.user_defined_link) {
    console.error("Error in LinkFlyout entry, no link object defined");
    return null;
  }
  return /* @__PURE__ */ jsx(
    UserDefinedLink,
    {
      entry: entry.user_defined_link,
      locale,
      analyticsTitlePrefix
    },
    entry.user_defined_link.link.title
  );
}
export {
  LinkFlyout
};
